import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "c-article-pagination__inner" }
const _hoisted_2 = ["href", "target", "aria-label"]
const _hoisted_3 = { class: "c-article-pagination__title" }
const _hoisted_4 = ["href", "target", "aria-label"]
const _hoisted_5 = { class: "c-article-pagination__title" }

import { computed } from 'vue';
import type { ArticlePaginationProps } from '@/types/components/ArticlePagination';
import utils from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticlePagination',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);

const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});

const previousLink = computed(() => fields.value?.previousLink?.value || {});
const nextLink = computed(() => fields.value?.nextLink?.value || {});

const previousTitle = computed(
  () =>
    fields.value?.previousTitle?.value || previousLink.value.text || previousLink.value.title || ''
);
const nextTitle = computed(
  () => fields.value?.nextTitle?.value || nextLink.value.text || nextLink.value.title || ''
);

const previousHref = computed(() => previousLink.value.href || '#');
const nextHref = computed(() => nextLink.value.href || '#');
const previousTarget = computed(() => previousLink.value.target || undefined);
const nextTarget = computed(() => nextLink.value.target || undefined);

return (_ctx: any,_cache: any) => {
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value)
    ? (_openBlock(), _createElementBlock("nav", {
        key: 0,
        class: "c-article-pagination",
        style: _normalizeStyle(rootStyle.value),
        "aria-label": "Article pagination"
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [2, 20],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (previousTitle.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "c-article-pagination__link c-article-pagination__link--previous",
                    href: previousHref.value,
                    target: previousTarget.value,
                    "aria-label": `Previous article: ${previousTitle.value}`
                  }, [
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "c-article-pagination__arrow c-article-pagination__arrow--previous" }, null, -1)),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(previousTitle.value), 1)
                  ], 8, _hoisted_2))
                : _createCommentVNode("", true),
              (nextTitle.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "c-article-pagination__link c-article-pagination__link--next",
                    href: nextHref.value,
                    target: nextTarget.value,
                    "aria-label": `Next article: ${nextTitle.value}`
                  }, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(nextTitle.value), 1),
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "c-article-pagination__arrow c-article-pagination__arrow--next" }, null, -1))
                  ], 8, _hoisted_4))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ], 4))
    : _createCommentVNode("", true)
}
}

})